//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {CollapseTransition} from "@ivanv/vue-collapse-transition";
import List from "./List.vue";

export default {
  components: {
    CollapseTransition,
    List,
  },
  data() {
    return {
      products: [
        {id: 0, backgroundColor: "#19383A", inversion: "white", attrId: '#bagConversedBss', hasVideo: true},
        {id: 1, backgroundColor: "#19383A", inversion: "white", attrId: '#bagDigitalBss', hasVideo: false},
        {id: 2, backgroundColor: "#0D475B", inversion: "white", attrId: '#bagNetworkMonetisationSuite', hasVideo: true},
        {id: 3, backgroundColor: "#E4E9EE", inversion: "black", attrId: '#bagIotPlatform', hasVideo: false},
      ],
      activeProduct: null,
      services: [
        {id:0},
        {id:1},
        {id:2}
      ]
    }
  },
  created() {
    this.products.forEach((el, key) => {
      this.$set(el, 'sort', key);
      this.$set(el, 'isActive', false);
    });
    this.activateItem(this.products[0]);
  },
  methods: {
    activateItem(item) {
      if (this.activeProduct) {
        this.activeProduct.isActive = false;
      }
      this.activeProduct = item;
      item.isActive = true;
    }
  }
};
